export function extractVideoCodeYouTube(texto: string): string[] {
	const regex =
		/(?:youtube\.com\/(?:.*v=|v\/|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/g;
	const matches = texto.matchAll(regex);
	return Array.from(matches, (m) => m[1]);
}
